// Why a trade participation cannot be transmitted, mirrored from the backend
// (Trades::Instance#cannot_transmit_reason). `null` means it can be transmitted.
// The reason→message mapping lives in each app (web + mobile) so the copy goes
// through Lingui; this package is intentionally i18n-framework-free and owns only
// the vocabulary (this type) and the display predicates below.
export type CannotTransmitReason =
  | 'external_source'
  | 'not_subscribed_or_refused'
  | 'trade_closed'
  | 'trade_upcoming'
  | 'payment_information_missing'
  | 'sellout_extract_in_progress'
  | 'pure_panelist_sellout'
  | 'signature_needed'
  | 'legal_entity_required'
  | 'requirements_window_over'
  | 'requirements_not_filled';

type CannotTransmitTrade = {
  kind: string;
  picture_requirement: unknown;
  sellout_requirement: unknown;
};

// A platform_connect trade whose proofs have not been synced from the external
// system yet: the requirements exist server-side but aren't exposed to the
// client, so no proof can be filled. A display nuance of the generic block that
// both apps reuse to pick the "syncing" message.
export const isTradeProofsSyncing = (trade: CannotTransmitTrade) =>
  trade.kind === 'platform_connect' && !trade.picture_requirement && !trade.sellout_requirement;

type LegalEntityTrade = { pharmacy_accounting_document_to_generate: string };

// Mirrors the `legal_entity_required` reason: only invoicing needs it.
export const pharmacyShouldFillLegalEntity = (
  trade: LegalEntityTrade,
  isLegalEntityValid?: boolean
) => trade.pharmacy_accounting_document_to_generate !== 'none' && !isLegalEntityValid;
